import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { onToggleShowKeyboardActions } from "developer/edit/store/toolbar";
import React, { useCallback } from "react";
import { useAppDispatch } from "store/hooks";

type MoreActionsProps = {};

const MoreActions: React.FC<MoreActionsProps> = () => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickShowMoreActions = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickShowKeyboardActions = useCallback(() => {
    dispatch(onToggleShowKeyboardActions(true));
    handleClose();
  }, [dispatch]);

  return (
    <>
      <Menu
        id="more-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClickShowKeyboardActions}>
          Show Keyboard Actions
        </MenuItem>
      </Menu>
      <IconButton size="small" onClick={handleClickShowMoreActions}>
        <Tooltip title="More Actions">
          <MoreVertIcon />
        </Tooltip>
      </IconButton>
    </>
  );
};

export default MoreActions;
